import type { CSSProperties } from "react";
import { House } from "lucide-react";
import type { BudgetOwner } from "../types";
import { defaultAvatarFor, type AvatarKey } from "../lib/profiles";
import { AVATAR_ART } from "./AvatarIcons";
import { useProfiles } from "./ProfilesContext";

export default function Avatar({
  owner,
  size = 44,
  avatar,
}: {
  owner: BudgetOwner;
  size?: number;
  /** Draw this picture instead of looking the profile up, for screens that have no profile list yet. */
  avatar?: AvatarKey;
}) {
  const profiles = useProfiles();
  if (owner === "Household")
    return (
      <span
        className="avatar household"
        style={{ width: size, height: size }}
        aria-label="Barnyard household"
      >
        <House size={size * 0.55} />
      </span>
    );
  const art = AVATAR_ART[avatar ?? profiles.find((p) => p.name === owner)?.avatar ?? defaultAvatarFor(owner)];
  return (
    <span
      className="avatar"
      style={{ width: size, height: size, color: art.fg, "--avatar-bg": art.bg } as CSSProperties}
    >
      <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
        {art.art}
      </svg>
    </span>
  );
}
